<script setup>
import { NFlex } from 'naive-ui';
import { computed } from 'vue';

import folder01 from '@/assets/images/result/folder_01.png';
import folder02 from '@/assets/images/result/folder_02.png';
import folder03 from '@/assets/images/result/folder_03.png'; 

const helperResources = computed(() => [
  {
    category: '초등',
    icon: folder01, 
    primaryColor: '#DE6413',
    title: '문해력·수리력 통합 수업활동 자료',
    descriptions: [
      '교육과정과 함께하는 초 3·4 문해력·수리력 수업 이렇게 할 수 있어요.',
      '수학과 영역별, 대주제, 소주제 자료',
      '초등 수리력 성장 나침반'
    ]
  },
  {
    category: '중등',
    icon: folder02, 
    primaryColor: '#1A951E',
    title: '성취기준 활용 선수학습 추출 자료', 
    descriptions: [
      '중·고 연계형 수학과 학생 맞춤형 지도자료(고1 성취기준을 중심으로)'
    ]
  },
  {
    category: '공통',
    icon: folder03, 
    primaryColor: '#005BAC',
    title: '핵심개념 중심 읽기·활동 자료',
    descriptions: [
      '초·중·고 독서기반 문해력 향상 자료집 「북돋움」'
    ]
  }
]);
</script>

<template>
  <div class="helper">
    <p class="text-[24px] pb-5 font-semibold">문해력·수리력 수업 도움 자료</p>
    <ul>
      <li v-for="(item, index) in helperResources" :key="index" :style="{ '--item-primary-color': item.primaryColor}">       
        <div class="icon-wrap" :style="{ backgroundImage: `url(${item.icon})` }">
          <span class="text-[20px] font-medium">{{ item.category }}</span>
        </div>
        <div class="text-wrap">
          <p>{{ item.title }}</p>
          <p v-for="(desc, dIndex) in item.descriptions" :key="dIndex">{{ desc }}</p>
        </div>                       
      </li>                  
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.helper {    
  min-width: 600px;
    ul {
        li {
            display: flex;
            gap: 20px;    
            padding: 16px 0;
            border-top: 2px dashed #ccc;   
            .icon-wrap {
                width: 74px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding-top: 20px;
                padding-right: 15px;
            }
            .text-wrap {
                p {padding-left: 20px;}
                p:nth-child(odd){ 
                    font-size: 20px;
                    font-weight: 500;
                    color: var(--item-primary-color);    
                    position: relative;      
                    line-height: 1.5;     
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;   
                        width: 5px;
                        height: 5px;
                        border-radius: 100%;         
                        top: 50%;
                        transform: translateY(-50%);      
                        background-color: var(--item-primary-color); 
                    }
                }    
                p:nth-child(even){
                    color: #333;
                } 
            }
            &:nth-child(1) .text-wrap p:nth-child(2) {padding-bottom: 5px;}
        }
    }    
}
</style>